/** Maximum rows rendered per group in the quick-search dropdown. */
export const GLOBAL_SEARCH_MAX_PER_GROUP = 5;
/** Id of the results listbox the global search combobox controls. */
export const GLOBAL_SEARCH_LISTBOX_ID = "global-search-listbox";
/** Ids of the group headings that label the listbox groups. */
export const GLOBAL_SEARCH_CONTACTS_HEADING_ID = "global-search-group-contacts";
export const GLOBAL_SEARCH_ORGANISATIONS_HEADING_ID = "global-search-group-organisations";
export function globalSearchOptionId(kind, entityId) {
    return `global-search-option-${kind}-${entityId}`;
}
export function globalSearchSeeAllOptionId(kind) {
    return `global-search-option-${kind}-see-all`;
}
/**
 * Options in the order the listbox renders them: each group's capped rows, then its
 * "see all" row. "See all" shows only when the delivered list exceeds the preview, never on
 * the total alone, so an over-reporting backend can't offer rows that don't exist.
 */
export function globalSearchOptions(results) {
    const groups = [
        { kind: "contact", ids: results.contacts.map((c) => c.id) },
        { kind: "organisation", ids: results.organisations.map((o) => o.id) },
    ];
    return groups.flatMap(({ kind, ids }) => {
        const options = ids
            .slice(0, GLOBAL_SEARCH_MAX_PER_GROUP)
            .map((entityId) => ({ id: globalSearchOptionId(kind, entityId), type: "result", kind, entityId }));
        if (ids.length > GLOBAL_SEARCH_MAX_PER_GROUP) {
            options.push({ id: globalSearchSeeAllOptionId(kind), type: "see-all", kind });
        }
        return options;
    });
}
